import {useEffect, useMemo, useState} from "react";
import axios from "axios";
import Helpers from "../Helpers";

const emptyTileCollection = {
  id: null,
  cssClass: "",
  title: "",
  text: "",
  tiles: []
};

export default function useTileCollection(token, id, enabled = true) {
  const {isNotEmpty} = Helpers();
  const canRequest = enabled && isNotEmpty(token) && isNotEmpty(id);
  const context = useMemo(() => ({token, id, canRequest}), [token, id, canRequest]);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    let active = true;
    setResponse(null);
    if (context.canRequest) {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${context.token}`
        },
        url: `${process.env.REACT_APP_API}/cms/tile-collections/${context.id}`,
      }).then(res => {
        if (active) {
          setResponse({context, status: "success", data: res.data});
        }
      }).catch(err => {
        if (active) {
          setResponse({
            context,
            status: err.response && [401, 403].includes(err.response.status) ? "denied" : "error"
          });
        }
      });
    }
    return () => { active = false; };
  }, [context]);

  // Match during render: effect-only clearing can expose an obsolete response.
  const current = canRequest && response && response.context === context ? response : null;
  const status = current ? current.status : canRequest ? "loading" : "idle";

  return {
    tileCollection: status === "success" ? current.data : emptyTileCollection,
    status,
    loading: status === "loading",
    denied: status === "denied",
    error: status === "error"
  };
}
